import * as RadioGroup from '@radix-ui/react-radio-group'
import * as React from 'react'

import { styled } from '~/styled'

const StyledRadioCard = styled(RadioGroup.Item, {
  base: [
    'items-center',
    'bg-white',
    'border',
    'border-grey-600',
    'rounded-sm',
    'cursor-pointer',
    'flex',
    'text-left',
    'data-[state=checked]:-outline-offset-2',
    'data-[state=checked]:outline-2',
    'data-[state=checked]:outline-primary-800',
    'data-[state=checked]:outline-solid'
  ],
  variants: {
    align: {
      left: ['flex-row'],
      right: ['flex-row-reverse']
    },
    size: {
      md: ['px-4', 'py-3'],
      lg: ['px-8', 'py-4']
    },
    isFullWidth: {
      true: ['w-full'],
      false: ['w-max']
    }
  }
})

const RadioButton = styled('div', {
  base: [
    'items-center',
    'appearance-none',
    'bg-transparent',
    'border',
    'border-grey-900',
    'rounded-full',
    'flex',
    'shrink-0',
    'justify-center',
    'p-0',
    'size-4',
    'transition-all',
    'duration-50',
    'ease-out',
    'in-data-[state=checked]:bg-primary-800',
    'in-data-[state=checked]:border-primary-800'
  ],
  variants: {
    containerIsFullWidth: {
      true: [],
      false: []
    },
    align: {
      left: ['mr-4'],
      right: []
    }
  },
  compoundVariants: [
    {
      containerIsFullWidth: true,
      align: 'right',
      class: ['ml-auto']
    },
    {
      containerIsFullWidth: false,
      align: 'right',
      class: ['ml-4']
    }
  ]
})

const Indicator = styled(RadioGroup.Indicator, {
  base: ['bg-white', 'rounded-full', 'absolute', 'size-1.5']
})

type RadioCardProps = React.ComponentProps<typeof StyledRadioCard>

export const RadioCard = ({
  children,
  isFullWidth = false,
  size = 'md',
  align = 'left',
  ...rest
}: RadioCardProps) => (
  <StyledRadioCard
    {...rest}
    align={align}
    isFullWidth={isFullWidth}
    size={size}
  >
    <RadioButton align={align} containerIsFullWidth={isFullWidth}>
      <Indicator />
    </RadioButton>
    <div>{children}</div>
  </StyledRadioCard>
)
